export default "__VITE_ASSET__90600815__"